/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdHJhdmlzL2J1aWxkL2luc3BpcmVoZXAvcmVjb3JkLWVkaXRvci9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL2ZpbGUtdXBsb2FkLWJ1dHRvbi9maWxlLXVwbG9hZC1idXR0b24uY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS90cmF2aXMvYnVpbGQvaW5zcGlyZWhlcC9yZWNvcmQtZWRpdG9yL3NyYy9hcHAvc2hhcmVkL2NvbXBvbmVudHMvZmlsZS11cGxvYWQtYnV0dG9uL2ZpbGUtdXBsb2FkLWJ1dHRvbi5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/$$_gendir/app/shared/components/file-upload-button/file-upload-button.component.scss.shim.ngstyle.ts